<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [draggable]="false" styleClass="w-full max-w-xl!" (onHide)="onClose()">
    <ng-template #header>
        <div>
            <p class="text-lg font-semibold">{{ 'CONFIGURE_TRIGGER' | translate }}</p>
            <p class="text-sm text-surface-400">{{ 'CONFIGURE_TRIGGER_SUBTITLE' | translate }}</p>
        </div>
    </ng-template>

    @if (editedTrigger(); as t) {
    <div class="flex! w-full flex-col gap-5 py-1">
        <div class="flex! flex-col justify-start items-start gap-1.5 w-full">
            <label class="text-sm text-surface-500">{{ 'NAME' | translate }}</label>
            <input
                pInputText
                [fluid]="true"
                type="text"
                [ngModel]="t.name"
                (ngModelChange)="updateTrigger({ name: $event })"
                [placeholder]="'TRIGGER_NAME_PLACEHOLDER' | translate" />
        </div>

        <div class="grid grid-cols-2 gap-4! w-full">
            <div class="flex! flex-col gap-1.5 w-full">
                <label class="text-sm text-surface-500">{{ 'EVENT' | translate }}</label>
                <p-select
                    [ngModel]="t.triggerData.name"
                    (ngModelChange)="updateTriggerEventType($event)"
                    [options]="triggerTypeOptions()"
                    optionLabel="label"
                    optionValue="value" />
            </div>
            <div class="flex! flex-col gap-1.5 w-full">
                <label class="text-sm text-surface-500">{{ 'ACTION' | translate }}</label>
                <p-select
                    [ngModel]="t.actionData.name"
                    (ngModelChange)="updateActionType($event)"
                    [options]="actionTypeOptions()"
                    optionLabel="label"
                    optionValue="value" />
            </div>
        </div>

        @if (showPackages()) {
        <div class="flex! flex-col gap-1.5 w-full">
            <label class="text-sm text-surface-500">{{ 'PACKAGES' | translate }}</label>
            <p-select
                [fluid]="true"
                [multiple]="true"
                [options]="availablePackages()"
                [ngModel]="packageIds()"
                (ngModelChange)="updatePackageIds($event)"
                optionLabel="name"
                optionValue="id"
                appendTo="body"
                [filter]="false"
                [placeholder]="'ALL_PACKAGES' | translate" />
        </div>
        }

        <div class="flex! gap-4! w-full items-center">
            @if (isBeforeBookingStart() && t.triggerData.beforeBookingData) {
            <div class="flex! flex-col gap-1.5">
                <label class="text-sm text-surface-500">{{ 'DELAY_BEFORE_BOOKING' | translate }}</label>
                <div class="flex! gap-2">
                    <p-inputnumber
                        [ngModel]="t.triggerData.beforeBookingData.timeValue"
                        (ngModelChange)="updateBeforeBookingData({ timeValue: $event })"
                        styleClass="w-28" />
                    <p-select
                        [ngModel]="t.triggerData.beforeBookingData.timeUnit"
                        (ngModelChange)="updateBeforeBookingData({ timeUnit: $event })"
                        [options]="[
                                    { label: ('MINUTES' | translate), value: 'minutes' },
                                    { label: ('HOURS' | translate), value: 'hours' },
                                    { label: ('DAYS' | translate), value: 'days' }
                                ]"
                        optionLabel="label"
                        optionValue="value" />
                </div>
            </div>
            } @if (isScheduleEmail() && t.actionData.scheduleEmailData) {
            <div class="flex! flex-col gap-1.5">
                <label class="text-sm text-surface-500">{{ 'DELAY' | translate }}</label>
                <div class="flex! gap-2">
                    <p-inputnumber
                        [ngModel]="t.actionData.scheduleEmailData.timeValue"
                        (ngModelChange)="updateScheduleEmailData({ timeValue: $event })"
                        styleClass="w-28" />
                    <p-select
                        [ngModel]="t.actionData.scheduleEmailData.timeUnit"
                        (ngModelChange)="updateScheduleEmailData({ timeUnit: $event })"
                        [options]="timeUnitOptions()"
                        optionLabel="label"
                        optionValue="value" />
                </div>
            </div>
            } @else if (isScheduleSms() && t.actionData.scheduleSmsData) {
            <div class="flex! flex-col gap-1.5">
                <label class="text-sm text-surface-500">{{ 'DELAY' | translate }}</label>
                <div class="flex! gap-2">
                    <p-inputnumber
                        [ngModel]="t.actionData.scheduleSmsData.timeValue"
                        (ngModelChange)="updateScheduleSmsData({ timeValue: $event })"
                        styleClass="w-28" />
                    <p-select
                        [ngModel]="t.actionData.scheduleSmsData.timeUnit"
                        (ngModelChange)="updateScheduleSmsData({ timeUnit: $event })"
                        [options]="timeUnitOptions()"
                        optionLabel="label"
                        optionValue="value" />
                </div>
            </div>
            } @if (isSendEmail() && t.actionData.sendEmailData) {
            <div class="flex! flex-col gap-1.5 w-full">
                <label class="text-sm text-surface-500">{{ 'RECEIVERS' | translate }}</label>
                <p-select
                    [fluid]="true"
                    [multiple]="true"
                    [filter]="false"
                    [ngModel]="t.actionData.sendEmailData.receivers"
                    (ngModelChange)="updateSendEmailData({ receivers: $event })"
                    [options]="receiverOptions()"
                    optionLabel="label"
                    appendTo="body"
                    optionValue="value"
                    [placeholder]="'SELECT_RECEIVERS' | translate" />
            </div>
            } @else if (isScheduleEmail() && t.actionData.scheduleEmailData) {
            <div class="flex! flex-col gap-1.5 w-full">
                <label class="text-sm text-surface-500">{{ 'RECEIVERS' | translate }}</label>
                <p-select
                    [fluid]="true"
                    [multiple]="true"
                    [filter]="false"
                    [ngModel]="t.actionData.scheduleEmailData.receivers"
                    (ngModelChange)="updateScheduleEmailData({ receivers: $event })"
                    [options]="receiverOptions()"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                    [placeholder]="'SELECT_RECEIVERS' | translate" />
            </div>
            } @else if (isSendSms() && t.actionData.sendSmsData) {
            <div class="flex! flex-col gap-1.5 w-full">
                <label class="text-sm text-surface-500">{{ 'RECEIVERS' | translate }}</label>
                <p-select
                    [fluid]="true"
                    [multiple]="true"
                    [filter]="false"
                    [ngModel]="t.actionData.sendSmsData.receivers"
                    (ngModelChange)="updateSendSmsData({ receivers: $event })"
                    [options]="receiverOptions()"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                    [placeholder]="'SELECT_RECEIVERS' | translate" />
            </div>
            } @else if (isScheduleSms() && t.actionData.scheduleSmsData) {
            <div class="flex! flex-col gap-1.5 w-full">
                <label class="text-sm text-surface-500">{{ 'RECEIVERS' | translate }}</label>
                <p-select
                    [fluid]="true"
                    [multiple]="true"
                    [filter]="false"
                    [ngModel]="t.actionData.scheduleSmsData.receivers"
                    (ngModelChange)="updateScheduleSmsData({ receivers: $event })"
                    [options]="receiverOptions()"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                    [placeholder]="'SELECT_RECEIVERS' | translate" />
            </div>
            }
        </div>

        @if (isSendEmail() && t.actionData.sendEmailData) {
        <div class="grid grid-cols-2 gap-4 w-full">
            <div class="flex! flex-col gap-1.5">
                <label class="text-sm text-surface-500">{{ 'EMAIL_SUBJECT' | translate }}</label>
                <input
                    pInputText
                    type="text"
                    [ngModel]="t.actionData.sendEmailData.subject"
                    (ngModelChange)="updateSendEmailData({ subject: $event })" />
            </div>
            <div class="flex! flex-col gap-1.5">
                <label class="text-sm text-surface-500">{{ 'EMAIL_SENDER_NAME' | translate }}</label>
                <input
                    pInputText
                    type="text"
                    [ngModel]="t.actionData.sendEmailData.senderName"
                    (ngModelChange)="updateSendEmailData({ senderName: $event })" />
            </div>
        </div>
        <button pButton class="mt-2" [fluid]="true" severity="secondary" (click)="onOpenEmailEditor()">
            <i class="ph ph-pencil-simple"></i>
            {{ 'EDIT_TEMPLATE' | translate }}
        </button>
        } @else if (isScheduleEmail() && t.actionData.scheduleEmailData) {
        <div class="grid grid-cols-2 gap-4 w-full">
            <div class="flex! flex-col gap-1.5">
                <label class="text-sm text-surface-500">{{ 'EMAIL_SUBJECT' | translate }}</label>
                <input
                    pInputText
                    type="text"
                    [ngModel]="t.actionData.scheduleEmailData.subject"
                    (ngModelChange)="updateScheduleEmailData({ subject: $event })" />
            </div>
            <div class="flex! flex-col gap-1.5">
                <label class="text-sm text-surface-500">{{ 'EMAIL_SENDER_NAME' | translate }}</label>
                <input
                    pInputText
                    type="text"
                    [ngModel]="t.actionData.scheduleEmailData.senderName"
                    (ngModelChange)="updateScheduleEmailData({ senderName: $event })" />
            </div>
        </div>
        <button pButton class="mt-2" [fluid]="true" severity="secondary" (click)="onOpenEmailEditor()">
            <i class="ph ph-pencil-simple"></i>
            {{ 'EDIT_TEMPLATE' | translate }}
        </button>
        } @if ((isSendSms() && t.actionData.sendSmsData) || (isScheduleSms() && t.actionData.scheduleSmsData)) {
        <div class="flex! w-full flex-col gap-1.5">
            <div class="flex justify-between items-center">
                <label class="text-sm text-surface-500">{{ 'SMS_CONTENT' | translate }}</label>
                <span class="text-xs text-surface-400">
                    {{ (isSendSms() ? t.actionData.sendSmsData?.message?.length : t.actionData.scheduleSmsData?.message?.length) ?? 0 }}/160
                    &bull; {{ getNumberOfSmsSegments( (isSendSms() ? t.actionData.sendSmsData?.message :
                    t.actionData.scheduleSmsData?.message) ?? '' ) }} {{ 'SEGMENTS' | translate }}
                </span>
            </div>

            @if (isSendSms()) {
            <textarea
                pTextarea
                [fluid]="true"
                [autoResize]="false"
                rows="4"
                [ngModel]="t.actionData.sendSmsData?.message ?? ''"
                (ngModelChange)="updateSendSmsData({ message: $event })"></textarea>
            } @else {
            <textarea
                pTextarea
                [fluid]="true"
                [autoResize]="false"
                rows="4"
                [ngModel]="t.actionData.scheduleSmsData?.message ?? ''"
                (ngModelChange)="updateScheduleSmsData({ message: $event })"></textarea>
            }

            <button pButton severity="secondary" size="small" class="w-fit" (click)="showPlaceholders.emit()">
                <i class="ph ph-brackets-curly"></i>
                {{ 'PLACEHOLDERS' | translate }}
            </button>
        </div>
        }
    </div>
    }

    <ng-template #footer>
        <button pButton severity="secondary" (click)="onClose()">{{ 'CANCEL' | translate }}</button>
        <button pButton (click)="onSave()">{{ 'SAVE_CHANGES' | translate }}</button>
    </ng-template>
</p-dialog>
